const RICOS_VERSION = "11.9.2";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
